import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  stepper: {
    padding: theme.spacing(3, 0, 5),
    '& .MuiStepIcon-root.MuiStepIcon-active': {
      color: '#667eea',
    },
    '& .MuiStepIcon-root.MuiStepIcon-completed': {
      color: '#11998e',
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    borderRadius: 10,
    textTransform: 'none',
    fontWeight: 600,
    padding: '10px 28px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
  cardPlan: {
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
    border: '1px solid rgba(0,0,0,0.06)',
    overflow: 'hidden',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
    },
  },
  cardHeaderPlan: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    textAlign: 'center',
    padding: theme.spacing(2, 3),
  },
  priceTag: {
    fontSize: '2.4rem',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  summaryCard: {
    borderRadius: 12,
    padding: theme.spacing(3),
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
  },
  summaryLabel: {
    color: '#6c757d',
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  summaryValue: {
    color: '#212529',
    fontWeight: 600,
    fontSize: '0.95rem',
  },
  totalRow: {
    borderTop: '2px solid #e9ecef',
    marginTop: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
  },
  paymentButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    width: '100%',
    marginTop: theme.spacing(3),
  },
  titleSection: {
    fontWeight: 700,
    color: '#2d3748',
    marginBottom: theme.spacing(2),
    fontSize: '1.15rem',
  },
}));
